// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3Hmem","header":"PatientQuestionnaire_header__3zqkz","info":"PatientQuestionnaire_info__1fXPM"};